import React, { useState } from 'react';
import classNames from 'classnames';
import { regionHasContent } from './helpers';
import RegionPicker from './region-picker';
import RegionsContent from './region-content';

const Regionalization = (props) => {
  const selectedRegion = props.RegionForm.Regions.Options.find(
    (item) => item.Selected === true
  );
  const region = selectedRegion ? selectedRegion : null;

  const [currentRegion, setCurrentRegion] = useState(region);
  const [regionPickerVisible, setRegionPickerVisible] = useState(false);

  const handleScreenReaderChangeRegion = (e) => {
    e.preventDefault();
  };

  const handleChangeRegion = (e) => {
    const selectedRegion = props.RegionForm.Regions.Options.find(
      (item) => item.Value === e.currentTarget.value
    );

    setCurrentRegion(selectedRegion);
    setRegionPickerVisible(false);
  };

  const handleToggleRegionPicker = () => {
    setRegionPickerVisible(!regionPickerVisible);
  };

  const getHeading = () => {
    const { RegionForm, RegionContent } = props;

    if (!region) return RegionForm.DefaultLabel;

    if (regionHasContent(currentRegion.Value, RegionContent))
      return RegionForm.AdditionLabel;

    return RegionForm.NoAdditionLabel;
  };

  const { RegionForm, RegionContent } = props;

  if (!RegionContent) return null;

  const toggleClass = classNames({
    'c-regionalization__toggle': true,
    'c-regionalization__toggle--is-expanded': regionPickerVisible,
  });

  return (
    <div className="c-regionalization hide-for-print">
      <div className="c-regionalization__header">
        <h2 className="c-regionalization__heading">{getHeading()}</h2>
        <button
          className={toggleClass}
          onClick={(e) => handleToggleRegionPicker(e)}
          aria-controls={props.UniqueBlockId}
          aria-expanded={regionPickerVisible}
        >
          {currentRegion ? currentRegion.Label : RegionForm.Regions.Label}
        </button>
      </div>
      <RegionPicker
        {...RegionForm.Regions}
        Id={props.UniqueBlockId}
        RegionContent={RegionContent}
        handleChangeRegion={(e) => handleChangeRegion(e)}
        handleScreenReaderChangeRegion={(e) =>
          handleScreenReaderChangeRegion(e)
        }
        regionPickerVisible={regionPickerVisible}
        currentSelectedRegion={currentRegion ? currentRegion.Value : null}
      />
      <RegionsContent
        Id={`content-${props.UniqueBlockId}`}
        RegionContent={RegionContent}
        currentRegion={currentRegion}
        regionPickerVisible={regionPickerVisible}
      />
    </div>
  );
};

export default Regionalization;
